import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "C:/Projekte/Experimente/github/react-gsap/node_modules/gatsby-theme-docz/src/base/Layout.js";
import { Fragment } from 'react';
import { Playground, Props } from 'docz';
import { Controls, PlayState } from './../../../react-gsap/src/';
import { Tween } from './Tween';
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <h1 {...{
      "id": "controls"
    }}>{`Controls`}</h1>
    <p>{`The Controls component is a helper that you can use to debug your animations.
Just wrap it around a Tween or Timeline component and you'll get control buttons and a slider.`}</p>
    <p>{`With the optional `}<inlineCode parentName="p">{`playState`}</inlineCode>{` prop you can set an initial play state.`}</p>
    <p>{`You can use the `}<inlineCode parentName="p">{`PlayState`}</inlineCode>{` enum/object or just the strings "play", "restart", "reverse", "restartReverse", "stop", "stopEnd", "pause" or "resume".`}</p>
    <pre><code parentName="pre" {...{}}>{`import { Controls, PlayState, Tween } from 'react-gsap';
`}</code></pre>
    <h3 {...{
      "id": "usage-with-tween"
    }}>{`Usage with Tween`}</h3>
    <Playground __position={0} __code={'<Controls playState={PlayState.restartReverse}>\n  <Tween to={{ x: \'200px\', rotation: 180 }} duration={2} ease=\"back.out(1.7)\">\n    <div style={{ width: \'100px\', height: \'100px\', background: \'#ccc\' }} />\n  </Tween>\n</Controls>'} __scope={{
      props,
      DefaultLayout,
      Fragment,
      Playground,
      Props,
      Controls,
      PlayState,
      Tween,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
  <Controls playState={PlayState.restartReverse} mdxType="Controls">
    <Tween to={{
          x: '200px',
          rotation: 180
        }} duration={2} ease="back.out(1.7)" mdxType="Tween">
      <div style={{
            width: '100px',
            height: '100px',
            background: '#ccc'
          }} />
    </Tween>
  </Controls>
    </Playground>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      